import React from 'react';
import { ChefHat, Cpu, Baby } from 'lucide-react';
import { motion } from 'framer-motion';

interface MenuTypeSelectorProps {
  useAI: boolean;
  isBabyMenu: boolean;
  onToggleAI: (useAI: boolean) => void;
  onToggleBabyMenu: (isBaby: boolean) => void;
}

export const MenuTypeSelector: React.FC<MenuTypeSelectorProps> = ({
  useAI,
  isBabyMenu,
  onToggleAI,
  onToggleBabyMenu
}) => {
  return (
    <div className="flex gap-2">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          onToggleAI(false);
          onToggleBabyMenu(false);
        }}
        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
          !useAI && !isBabyMenu ? 'bg-orange-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        <ChefHat size={20} />
        Menú Básico
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          onToggleAI(true);
          onToggleBabyMenu(false);
        }}
        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
          useAI && !isBabyMenu ? 'bg-orange-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        <Cpu size={20} />
        Menú con IA
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => {
          onToggleAI(false);
          onToggleBabyMenu(true);
        }}
        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
          isBabyMenu ? 'bg-pink-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        <Baby size={20} />
        Menú Bebé
      </motion.button>
    </div>
  );
};